import React from 'react'

type SafeFreestarWrapperProps = {
  children: React.ReactNode
  logRenderEvent?: boolean
  source: string
}

type ErrorBoundaryProps = {
  children: React.ReactNode
  placementName?: string
  source: string
}

type ErrorBoundaryState = {
  hasError: boolean
}

class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(_: Error): ErrorBoundaryState {
    return { hasError: true }
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('Error caught in Freestar ErrorBoundary:', error)
  }

  render() {
    if (this.state.hasError) return null
    return this.props.children
  }
}

const SafeFreestarWrapper: React.FC<SafeFreestarWrapperProps> = ({ children, logRenderEvent = true, source }) => {
  let placementName: string | undefined

  if (React.isValidElement(children)) {
    placementName = (children.props as { placementName?: string })?.placementName
  }

  return (
    <ErrorBoundary source={source} placementName={placementName}>
      {children}
    </ErrorBoundary>
  )
}

export default SafeFreestarWrapper
